import { createReducer } from '@reduxjs/toolkit';
import { LoadingStatuses } from 'core/common/entities';
import {
  saveFeature,
  loadFeaturesSucceed,
  loadFeaturesFailed,
  loadFeaturesPending,
  updateConfig,
} from './actions';
import { featureFlagsInitialState } from './state';

export const featureFlagsReducer = createReducer(featureFlagsInitialState, (builder) => {
  builder
    .addCase(saveFeature, (state, { payload }) => {
      state.features = { ...state.features, [payload.name]: payload.value };
    })
    .addCase(updateConfig, (state, { payload }) => {
      state.config = payload;
    })
    .addCase(loadFeaturesPending, (state) => {
      state.loadingStatus = LoadingStatuses.PENDING;
    })
    .addCase(loadFeaturesSucceed, (state, { payload }) => {
      state.config = payload;
      state.loadingStatus = LoadingStatuses.FULFILLED;
    })
    .addCase(loadFeaturesFailed, (state) => {
      state.loadingStatus = LoadingStatuses.FAILED;
    });
});
